<template>
    <div>
        <vxe-modal v-model="previewData" title="导入数据预览" width="1500" min-width="1000" resize>
            <template v-slot>
                <div style="display: block;  height: calc(100vh - 179px);">
                    <vxe-button status="primary" size="mini" icon="fa fa-save" @click="save"></vxe-button>
                    <vxe-table size="mini" border resizable show-overflow auto-resize remember storage transfer
                        height="auto" :sync-resize="previewData" :data="tableData" align="center"
                        style="font-size: calc(14vw * 100 / 1920);" row-key highlight-hover-row>
                        <vxe-table-column sortable type="seq" title="序号"></vxe-table-column>
                        <vxe-table-column sortable field="erpCode" title="ERP编码"></vxe-table-column>
                        <vxe-table-column sortable field="hsCode" title="海关编码"></vxe-table-column>
                        <vxe-table-column sortable field="erpName" title="ERP名称"></vxe-table-column>
                        <vxe-table-column sortable field="hsName" title="海关名称"></vxe-table-column>
                        <!-- <vxe-table-column sortable field="unit" title="成交单位"></vxe-table-column> -->
                        <vxe-table-column sortable field="element" title="申报要素"></vxe-table-column>
                        <vxe-table-column sortable field="note" title="备注"></vxe-table-column>
                    </vxe-table>
                </div>
            </template>
            
        </vxe-modal>
       
    </div>
</template>

<script>
export default {
    name: 'previewTable',
    props: ['excelList',],
    data() {
        return {
            previewData: false,
            tableData: [],

        }
    },
    methods: {
        getData() {
            this.tableData = this.excelList;
        },
        save() {
            const arr = [];
            this.tableData.forEach(element => {
                arr.push({
                    erpCode: element.erpCode,
                    hsCode: element.hsCode,
                    erpName: element.erpName,
                    hsName: element.hsName,
                    unit: element.unit,
                    element: element.element,
                    note: element.note,
                })
            });
            this.$api.insSample( arr ).then(res =>{
                this.$emit('previewSonClose', false);
                this.$message({
                    type: 'success',
                    message:'上传成功'
                })
                this.$parent.submit();
        })
        },
    },

}
</script>

<style lang="scss" scoped></style>